/**
 * formatDate
 * 
 * "YYYY-MM-DD" 形式の日付文字列を "YYYY.M.D" 形式に変換する関数
 * 
 * @param {string} dateString - "YYYY-MM-DD" の形式の日付文字列
 * @returns {string} - "YYYY.M.D" の形式の日付文字列
 */
export const formatDate = (dateString) => {
    // 0回の場合や不正な形式の場合は '-' を返す
if (typeof dateString !== 'string') return '-';
  const parts = dateString.split('-');
  if (parts.length !== 3) return '-';
  const [year, month, day] = parts;
  return `${year}.${parseInt(month)}.${parseInt(day)}`;
  };
  

 /**
 * formatDateTime
 * 
 * 指定されたISO形式の日付文字列（例：2024-10-21T17:00:00Z）を受け取り、
 * `年.月.日 時間:分` のフォーマット（例：2024.10.21 17:00）で返します。
 *
 * @param {string} dateString - ISO形式の日付文字列 (例: '2024-10-21T17:00:00Z')
 * @returns {string} フォーマット済みの日付文字列 (例: '2024.10.21 17:00')
 */
export function formatDateTime(dateString) {

    // 0回の場合や無効な形式は '-' を返す
      if (!dateString || isNaN(new Date(dateString))) return '-';

    // 引数のISO形式日付文字列をDateオブジェクトに変換
    const date = new Date(dateString);

    // 年、月、日、時間、分の各要素を取得し、フォーマット用に0埋め（ゼロパディング）を行う
    const year = date.getFullYear(); // 年を取得
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月を取得し、1から12の範囲に補正
    const day = String(date.getDate()).padStart(2, '0'); // 日を取得
    const hours = String(date.getHours()).padStart(2, '0'); // 時を取得
    const minutes = String(date.getMinutes()).padStart(2, '0'); // 分を取得

    // フォーマットに従い、年.月.日 時間:分 の文字列を生成して返す
    return `${year}.${month}.${day} ${hours}:${minutes}`;
}


/**
 * getLatestDate
 * 
 * アイテムのリストから最新の日付を取得します。日付の降順でソートし、
 * 一番新しい日付をISOフォーマットの `年-月-日` 部分だけを返します。
 * アイテムリストが空か日付が無い場合は 'N/A' を返します。
 *
 * @param {Array} items - 日付を含むオブジェクトの配列 (例: [{ date: '2024-10-21' }, ...])
 * @returns {string} 最新の日付 (例: '2024-10-21')
 */
export function getLatestDate(items) {
    return items
        ?.map(item => new Date(item.date))
        .sort((a, b) => b - a)[0]
        ?.toISOString().split('T')[0] || 'N/A';
  }